export const Radio = ({ className, name, label, value, checked, onChange }) => {
    return (
        <label
            htmlFor={value}
            className={`radio ${className}`}
        >
            <input
                id={value}
                type="radio"
                value={value}
                checked={checked}
                name={name}
                onChange={onChange}
            />
            <span className="checkmark"></span>
            {label}
        </label>
    );
};
